import { endpoint, remoteCreate, remoteModifyPut } from "./utils.js";
import axios from 'axios';
import { objComparatorNumber } from "../utils.js";

type RawClient = {
  id: number;
  name: string;
  parks: Array<number>;
  email: string;
  pennylane_id: string;
};

export type Client = RawClient & { visual_name: string; };

export function clientRootURL() {
  return endpoint("internal/current/clients/");
}

export async function fetchClients(): Promise<Array<Client>> {
  const res = await axios.get<Array<RawClient>>(clientRootURL(), { withCredentials: true });
  return res.data.sort((a, b) => objComparatorNumber(a, b, 'id')).map(
    el => ({ ...el, visual_name: `${el['id']} - ${el['name']}` })
  );
}

export async function createClient(useAlerts: any, payload: any): Promise<void> {
  await remoteCreate(useAlerts, clientRootURL(), payload, 'Client', 'Client');
}

export async function modifyPutClients(useAlerts: any, payload: any, clientId: number): Promise<void> {
  await remoteModifyPut(useAlerts, `${clientRootURL()}${clientId}/`, payload, 'Client', 'Client');
}
